import React from 'react'

type Props = {
    brandId?: any
}

const _color = {
    31:'#6778E3',
    32:'#6778E3',
    33:'#b21418',
    34:'#b21418',
    39:'#e67030',
    40:'#e67030',
    46:'#08a6ff',
    47:'#08a6ff'
   
}

function CryptoWithdrawalIcon({ brandId=31 }: Props) {
    const fillColor = _color[brandId] || '#6778E3';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={35}
            height={31}
            fill="none"
        >
            <path
                fill="#fff"
                d="M5.973 3.23V5.56h24.95c2.553 0 3.936 1.374 3.936 3.918v17.635c0 2.506-1.393 3.89-3.889 3.89H4.01c-2.448 0-3.85-1.403-3.85-3.86V7.05C.16 3.384 2.606.927 6.272.927H26.58c1.644 0 2.921.87 3.337 2.293-7.971.01-15.923.01-23.943.01Z"
            />
            <path
                fill={fillColor}
                fillRule="evenodd"
                d="M17.495 11.367a7.825 7.825 0 0 1 4.24 4.387l-2.888.057a5.274 5.274 0 0 0-4.61-2.496c-2.907.056-5.221 2.418-5.17 5.275.052 2.857 2.453 5.126 5.362 5.069a5.29 5.29 0 0 0 4.514-2.676l2.888-.057a7.85 7.85 0 0 1-4.076 4.55l.06 3.29-2.633.052-.048-2.613a8.155 8.155 0 0 1-1.316.025l.049 2.613-2.634.052-.06-3.29c-2.742-1.172-4.68-3.832-4.738-6.963-.058-3.13 1.78-5.865 4.478-7.145l-.061-3.29 2.633-.052.048 2.614a8.144 8.144 0 0 1 1.317-.026L14.8 8.13l2.634-.051.061 3.288Z"
                clipRule="evenodd"
            />
            <path
                fill={fillColor}
                d="M31 18.441c.029 1.904-1.526 3.514-3.42 3.558-1.951.044-3.58-1.552-3.58-3.5 0-1.903 1.57-3.484 3.478-3.499 1.893-.029 3.492 1.538 3.522 3.441Z"
            />
        </svg>
    )
}

export function CryptoWithdrawalIcon2({ brandId=31 }: Props) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={33}
        height={33}
        fill="none"
        className='CryptoWIcon2'
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M19.214 11.171a6.068 6.068 0 0 1 3.289 3.403l-2.24.044a4.091 4.091 0 0 0-3.576-1.936c-2.254.044-4.05 1.875-4.01 4.091.04 2.216 1.903 3.976 4.159 3.931a4.103 4.103 0 0 0 3.5-2.075l2.24-.044a6.088 6.088 0 0 1-3.16 3.53l.046 2.55-2.042.04-.037-2.026c-.34.034-.68.04-1.021.02l.038 2.026-2.043.04-.047-2.55c-2.126-.91-3.63-2.974-3.674-5.401-.045-2.428 1.38-4.55 3.473-5.542L14.06 8.72l2.043-.04.037 2.026c.34-.034.68-.04 1.021-.02l-.038-2.026 2.043-.04.047 2.55Z"
          clipRule="evenodd"
        />
        <circle
          cx={16.511}
          cy={16.55}
          r={11.476}
          stroke="#fff"
          strokeWidth={1.601}
          transform="rotate(24.183 16.511 16.55)"
        />
      </svg>
    )
}

export default CryptoWithdrawalIcon